export const getLastVisitedPage = () => {
  return localStorage.getItem('last_visited');
};

export const setLastVisitedPage = page => {
  localStorage.setItem('last_visited', page);
};
